<template>
  <v-dialog
    v-model="value.visibilidade"
    :fullscreen="$attrs.fullscreen"
  >
    <v-card
      class="overflow-hidden"
      flat
    >
      <!-- Barra de título -->
      <v-app-bar
        absolute
        elevate-on-scroll
        scroll-target="#scrolling-techniques-7"
        class="pa-2"
      >
        <h1 class="primary--text title">
          {{ value.titulo }}
        </h1>
        <v-spacer />
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn
              color="error"
              text
              @click="value.visibilidade = false"
              v-on="on"
            >
              <v-icon class="mr-2">
                close
              </v-icon>
              Fechar
            </v-btn>
          </template>
          <span>Clique no botão para fechar</span>
        </v-tooltip>
      </v-app-bar>

      <!-- Visualização -->
      <v-sheet
        id="scrolling-techniques-7"
        class="overflow-y-auto mt-12"
      >
        <v-container
          id="view"
          :style="`height:${altura}px;`"
        >
          <!-- Slot para repassar conteúdo -->
          <slot name="body" />
        </v-container>
      </v-sheet>

      <!-- Área de Ações -->
      <v-card-actions class="pa-4 ma-2">
        <v-spacer />
        <!-- Slot para repassar botões -->
        <slot name="actions" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'AppWindow',

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    altura() {
      if (this.value.fullscreen) {
        return this.value.actions ? 780 : 820;
      }
      if (this.value.actions) {
        return 680;
      }
      return 720;
    },
  },

  watch: {
    'value.visibilidade': function (value) {
      if (!value && document.getElementById('view')) {
        document.getElementById('view').scrollIntoView();
      }
    },
  },

  mounted() {
    document.addEventListener('keyup', this.keyboardEvent);
  },

  destroyed() {
    document.removeEventListener('keyup', this.keyboardEvent);
  },

  methods: {
    keyboardEvent(e) {
      if (e.keyCode === 27) {
        this.value.visibilidade = false;
      }
    },
  },
};
</script>
